var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 24.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_11967_47288)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5389,
    cy: 24.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_11967_47288)",
    fillOpacity: 0.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 12.5,
    rx: 12.5,
    ry: 12.5,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 11.986V8.99935C18.0002 8.26602 17.4002 7.66602 16.6668 7.66602H8.66683C7.9335 7.66602 7.3335 8.26602 7.3335 8.99935V16.9993C7.3335 17.7327 7.9335 18.3327 8.66683 18.3327H16.6668C17.4002 18.3327 18.0002 17.7327 18.0002 16.9993V14.0127L20.6668 16.666V9.33268L18.0002 11.986ZM16.6668 11.4593V16.9993H8.66683V8.99935H16.6668V11.4593Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 12.9987C13.4032 12.9987 14.0002 12.4017 14.0002 11.6654C14.0002 10.929 13.4032 10.332 12.6668 10.332C11.9304 10.332 11.3335 10.929 11.3335 11.6654C11.3335 12.4017 11.9304 12.9987 12.6668 12.9987Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 15.286C15.3333 14.746 15.0133 14.266 14.52 14.0527C13.9533 13.806 13.3267 13.666 12.6667 13.666C12.0067 13.666 11.38 13.806 10.8133 14.0527C10.32 14.266 10 14.746 10 15.286V15.666H15.3333V15.286Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11967_47288",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 24.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11967_47288",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5389 24.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertsInactive);
export default __webpack_public_path__ + "static/media/experts-inactive.82098a6a8e107c147c28bbbb6b2b46dc.svg";
export { ForwardRef as ReactComponent };